<template>
  <div class="shop">
    <div class="hint">
      因药房不会存放过多库存，上门购买前，请提前联系药房备货！
    </div>
    <div class="shop-list">
      <div
        class="shop-item"
        v-for="(item, index) in shopList"
        :key="index"
        @click="openMap(item)"
      >
        <div class="item-info">
          <p class="item-name">
            {{ item.name }}
          </p>
          <a class="item-phone" :id="item.phone" @click.stop="call(item.phone)">
            {{ item.phone }}
          </a>
          <p class="item-address">
            {{ item.detailed_address }}
          </p>
        </div>
        <div class="right-arrow"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStoreList } from "../../../api/user";
export default {
  data() {
    return {
      shopList: [],
      page: 1,
      isEnd: false
    };
  },
  mounted() {
    this.getStoreList();
    window.addEventListener("scroll", this.debounce(this.onReachBottom));
  },
  methods: {
    getStoreList() {
      let data = {
        page: this.page
      };
      getStoreList(data).then(res => {
        console.log("store");
        console.log(res);
        if (res.data.list.length == 0) {
          this.isEnd = true;
        }
        this.shopList = this.shopList.concat(res.data.list);
      });
    },
    call(number) {
      console.log(number);
      const a = document.getElementById(number);
      //给a标签赋值
      a.setAttribute("href", `tel:${number}`);
      a.click();
    },
    openMap(item) {
      console.log(item);
      //打开地图导航
      let position = item.longitude + "," + item.latitude;
      window.open(
        `https://uri.amap.com/marker?position=${position}&name=${
          item.detailed_address
        }`
      );
    },
    debounce(fn, e) {
      // console.log(e);
      let time = null;
      // let that = this;
      return function() {
        if (time) {
          clearTimeout(time);
        }
        time = setTimeout(function() {
          fn(e);
        }, 200);
      };
    },
    onReachBottom() {
      //滚动内容距离顶部的距离
      let top = document.body.top || document.documentElement.scrollTop;
      console.log(top);
      //显示区域高度
      let clientHeight = document.documentElement.clientHeight;
      //滚动内容高度(全部内容高度)
      let scrollHeight = document.documentElement.scrollHeight;
      if (top + clientHeight >= scrollHeight - 10) {
        if (!this.isEnd) {
          this.page++;
          this.getStoreList();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.shop {
  padding-bottom: 40rpx;
  .hint {
    width: 100%;
    padding: 10px 5px;
    box-sizing: border-box;
    color: #f62c2c;
    font-size: 15px;
    background-color: #ffffff;
    margin-bottom: 10px;
  }
  &-item {
    padding: 10px 25px;
    box-sizing: border-box;
    font-size: 15px;
    background-color: #ffffff;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
  }
  .item-info {
    flex-grow: 1;
    margin-right: 20px;
  }
  .item-name {
    display: block;
    font-size: 20px;
  }
  .item-address {
    line-height: 15px;
    font-weight: lighter;
  }
  .item-phone {
    line-height: 15px;
    font-weight: lighter;
    padding: 5px 0;
  }
  .right-arrow {
    width: 20px;
    height: 20px;
    border-right: solid 2px #000000;
    border-top: solid 2px #000000;
    transform: rotate(45deg);
  }
}
</style>
